import React from 'react';
import { AffiliateLinkShare } from '../../components';

import css from './ListingPage.module.css';

const SectionAffiliateLink = props => {

  const { currentUser } = props;

  if (currentUser === null || currentUser.attributes.profile.protectedData.type !== '3'   ) {
    return null;
  }

  return (
    <div className={css.sectionAffiliateLink}>
       <AffiliateLinkShare listing={true} buttonId={'listingButton'} {...props}/>
    </div>
  );
};

export default React.memo(SectionAffiliateLink);
